import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useServiceReceiptsStyles = makeStyles({
  // Guía, "Números": tabulares.
  countPill: {
    fontVariantNumeric: 'tabular-nums',
  },
  emptyCount: {
    color: 'var(--ichtys-text-secondary)',
  },
  // Sección "Comprobantes" del drawer del servicio (GuideDrawerSection): separada del formulario por un divisor.
  section: {
    paddingTop: tokens.spacingVerticalL,
    ...shorthands.borderTop('1px', 'solid', 'var(--ichtys-border)'),
  },
  // Título de sección (16 / Bold lo pone GuideDrawerSection) con el contador al lado.
  sectionTitle: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
});
